import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "exchange-bottom-tabs" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "exchange-bottom-tabs__button-text" }

import { ToggleInputCustomEvent } from '@1trading/design-system';
import { orderBy } from 'lodash/fp';
import { isMobile } from 'mobile-device-detect';
import { computed, onBeforeUnmount, onMounted, ref, watch, type ComputedRef, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import { partnersService } from '@exchange/libs/partners/service/src';

import { tabs as bottomNavTabs, type TabValues, type TabInfo, type TabKeys } from './bottom-tabs';

interface BottomTabInfo extends TabInfo {
  isActive: ComputedRef<boolean>;
  translation: ComputedRef<string>;
  showGreenDot: ComputedRef<boolean>;
}


const __default__ = {
  name: 'ExchangeBottomTabs',
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  activeTab: { type: String as PropType<TabKeys>, required: true },
  bottomTabs: { type: Object as PropType<Record<TabKeys, TabValues>>, required: true },
},
  emits: ["bottom-tab:clicked"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n({ useScope: 'global' });

const { showPartnersDot } = partnersService;

const showGreenDot = computed(() => showPartnersDot.value);

const getTabsInfo = () => {
  const ts = Object.values(props.bottomTabs).reduce((acc, tab) => {
    const isActive = computed(() => props.activeTab === tab.key);
    const tabGreenDot = computed(() => [bottomNavTabs.PROFILE.key].some((key) => key === tab.key) && showGreenDot.value);

    acc.push({
      ...tab,
      translation: computed(() => t(`modules.ExchangeNavigationTabs.${tab.key}`)),
      isActive,
      showGreenDot: tabGreenDot,
    });

    return acc;
  }, [] as Array<BottomTabInfo>);

  return orderBy(['order'], ['asc'], ts);
};

const tabs = ref(getTabsInfo());
watch(
  () => props.bottomTabs,
  () => {
    tabs.value = getTabsInfo();
  },
);
const onTabClick = (tabKey: TabValues) => {
  emit('bottom-tab:clicked', tabKey);
};

const useToggleBottomNav = () => {
  const keyboardIsVisible = ref(false);

  const onInputStateChange = (event: ToggleInputCustomEvent) => {
    keyboardIsVisible.value = event.detail.focused;
  };

  onMounted(() => {
    window.addEventListener(ToggleInputCustomEvent.type, onInputStateChange as EventListener, true);
  });

  onBeforeUnmount(() => {
    window.removeEventListener(ToggleInputCustomEvent.type, onInputStateChange as EventListener, true);
  });

  const shouldBottomTabsBeVisible = computed(() => !keyboardIsVisible.value || !isMobile);

  const shouldBottomTabsBeVisibleDelayed = ref(shouldBottomTabsBeVisible.value);

  watch(
    shouldBottomTabsBeVisible,
    (value) => {
      if (value) {
        setTimeout(() => {
          shouldBottomTabsBeVisibleDelayed.value = true;
        }, 100);
      } else {
        shouldBottomTabsBeVisibleDelayed.value = false;
      }
    },
    { immediate: true },
  );

  return {
    shouldBottomTabsBeVisibleDelayed,
  };
};
const { shouldBottomTabsBeVisibleDelayed } = useToggleBottomNav();

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
      return (_openBlock(), _createElementBlock("button", {
        key: tab.key,
        class: _normalizeClass(['exchange-bottom-tabs__button', { 'exchange-bottom-tabs__button--active': tab.isActive }]),
        onClick: ($event: any) => (onTabClick(tab))
      }, [
        (_openBlock(), _createBlock(_component_ot_icon, {
          key: tab.icon,
          class: _normalizeClass(["exchange-bottom-tabs__button-icon", [`test-${tab.key}`, 'exchange-bottom-tabs__button-icon', { 'exchange-bottom-tabs__button-icon--show-green-dot': tab.showGreenDot }]]),
          name: tab.icon,
          "inherit-stroke": true
        }, null, 8, ["name", "class"])),
        _createElementVNode("div", _hoisted_3, _toDisplayString(tab.translation), 1)
      ], 10, _hoisted_2))
    }), 128))
  ], 512)), [
    [_vShow, _unref(shouldBottomTabsBeVisibleDelayed)]
  ])
}
}

})